import { useEffect } from "react";
import { useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import "./Portfolio.css";
import Project from "./Project/Project";

const Portfolio = () => {
  const [projects, setProjects] = useState([]);

  const loadAdScript = () => {
    const script = document.createElement("script");
    script.src =
      "//pl28201795.effectivegatecpm.com/d4/51/1c/d4511c092526500cae3f7b04d5d02c19.js";
    script.type = "text/javascript";
    document.head.appendChild(script);
  };

  useEffect(() => {
    loadAdScript();
    fetch("projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <div>
      <Header></Header>
      <div className="title text-center pt-5 md:pt-20 lg:pt-20">
        <h1 className="text-2xl md:text-5xl lg:text-5xl font-bold">
          MY <span className="text-[orange]">PORTFOLIO</span>{" "}
        </h1>
        <p className="mt-5 text-[12px] md:text-[16px] lg:text-[16px] mb-0">
          I DEVELOP AND CODE BEAUTIFUL THINGS, AND I LOVE WHAT I DO.
        </p>
      </div>
      <div className="flex justify-center mt-5 lg:mt-16 px-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 py-5">
          {projects.map((project) => (
            <Project key={project.id} project={project}></Project>
          ))}
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Portfolio;
